import Player from '@vimeo/player';
import { calcBackgroundVideoSize } from '../modules/background-videos-size';
import { getRandomBackground } from '../modules/random-background';

$('.js-video-simple').each(function () {
  const $video = $(this);
  const videoUrl = $video.data('video');
  const autoplay = $video.attr('data-autoplay');

  if (videoUrl.includes('vimeo.com')) {
    const videoId = videoUrl.substring(videoUrl.lastIndexOf('/') + 1);
    const options = {
      id: videoId,
    };

    // Create Vimeo Player
    const player = new Player($video, options);

    player.ready().then(function () {
      // Has autoplay attribute
      if (typeof autoplay !== typeof undefined && autoplay !== false) {
        player['play']();
      }
    });
  }
});

$('.js-video-background').each(function () {
  const $video = $(this);
  let videoUrl = $video.data('video');
  if (videoUrl.includes('@')) {
    const randomVideo = getRandomBackground(videoUrl);
    videoUrl = randomVideo;
  }
  const videoId = videoUrl.split('?v=').pop();

  if (videoUrl.includes('vimeo.com')) {
    const videoId = videoUrl.substring(videoUrl.lastIndexOf('/') + 1);
    const options = {
      id: videoId,
      background: true,
      autopause: false,
    };

    // Create Vimeo Player
    const player = new Player($video, options);

    player.ready().then(function () {
      // Autoplay
      player['play']();

      calcBackgroundVideoSize();

      $(window).on('resize orientationchange', function () {
        calcBackgroundVideoSize();
      });
    });
  }
});

$('.js-video-control').each(function () {
  const $video = $(this);
  const $container = $video.closest('.js-video');
  const $btn = $container.find('.js-btn-play');
  const videoUrl = $video.data('video');

  if (videoUrl.includes('vimeo.com')) {
    const videoId = videoUrl.substring(videoUrl.lastIndexOf('/') + 1);
    const options = {
      id: videoId,
    };

    // Create Vimeo Player
    const player = new Player($video, options);

    // Button Play
    $btn.on('click touchstart', function (event) {
      event.preventDefault();

      if (player['play']) {
        $container.addClass('is-playing');
        player['play']();
      }
    });

    player.on('ended', function () {
      $container.removeClass('is-playing');
    });
  }
});
